import { useGetABOProfileQuery } from "../../../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../../../store";
import { LeafErrorMessage } from "../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import ApplicantItem from "../../../../components/ABOProfile/ApplicantComponents/ApplicantItem/ApplicantItem";
import "./ABOApplicantBody.scss";
import {
  cardActionClickTrack,
  profileApplicantCardErrorTrack,
} from "../../../../common/tealium/ABOProfile/Profile/ApplicantCardTrack";

type Props = {
  isShowApplicant: boolean;
};

const ABOApplicantBody = (props: Props) => {
  const { isShowApplicant } = props;

  // Get Login ABO
  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const [aff = "", abo = ""] = affAbo.split("-");
  const boot = useAppSelector(({ boot }) => boot);
  const profileInfo = boot?.configuration?.profile?.aboInfo || {};

  const applicantTrackOnclick = (event?: string) => {
    cardActionClickTrack(event, false);
  };

  const { isFetching, isError, data } = useGetABOProfileQuery({
    aff,
    abo,
    ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}),
  });

  if (isError === true) {
    profileApplicantCardErrorTrack();
  }

  if (isShowApplicant && isFetching === false && data?.aboInfo && data.partyInfo) {
    const { aboInfo, partyInfo } = data;
    const applicantList = partyInfo.filter(({ isPrimary }) => isPrimary === false);

    return (
      <div className="abo-applicant-body">
        {applicantList.map((info, index) => {
          return (
            <div className="abo-applicant-body__card" key={index}>
              <ApplicantItem
                key={index}
                isExpandable={false}
                aboInfo={aboInfo}
                partyInfo={info}
                applicantTrackOnclick={applicantTrackOnclick}
                profileInfo={profileInfo}
              />
            </div>
          );
        })}
      </div>
    );
  }

  return <LeafErrorMessage show={isError} />;
};

export default ABOApplicantBody;
